<template>
  <div>
    <CheckCircleIcon
      v-if="status === 'green'"
      class="text-green-500 h-6"
    />
    <ExclamationIcon
      v-else-if="status === 'yellow'"
      class="text-yellow-500 h-6"
    />
    <XCircleIcon
      v-else-if="status === 'red'"
      class="text-red-500 h-6"
    />
    <ClockIcon
      v-else
      class="h-6"
    />
  </div>
</template>

<script>
import {
  CheckCircleIcon, ClockIcon, ExclamationIcon, XCircleIcon,
} from '@heroicons/vue/solid';

export default {
  name: 'StatusTickCross',
  components: {
    ClockIcon,
    CheckCircleIcon,
    ExclamationIcon,
    XCircleIcon,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
};
</script>
